export default "__VITE_ASSET__otFlLUyP__"